import { render, staticRenderFns } from "./cgpthgz2026.vue?vue&type=template&id=f56d92ec&scoped=true"
import script from "./cgpthgz2026.vue?vue&type=script&lang=js"
export * from "./cgpthgz2026.vue?vue&type=script&lang=js"
import style0 from "./cgpthgz2026.vue?vue&type=style&index=0&id=f56d92ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d92ec",
  null
  
)

export default component.exports